import React from 'react';

import TableDisplay from './TableDisplay';

import {Data} from '../services/data-manager';
import { Modal } from 'react-bootstrap';
import Moment from 'react-moment';
import { notifyDanger, notifySuccess } from '../utils';
import Notification from 'react-notify-toast';
import { droitsAcces, modesPaiementMobile, pays } from '../config/globales';
import ReactToPrint from 'react-to-print';

class EtatFinancier extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            partenaire: null,
            showDetail: false,
            partenaires: [],
            recherche: {
                dateDebut: "",
                dateFin: "",
                motCle: "",
                tri: ""
            },
            enTraitement: false
        };
        this.getPartenaires = this.getPartenaires.bind(this);
        this.handleRechercheForm = this.handleRechercheForm.bind(this);
        this.handleInputRecherche = this.handleInputRecherche.bind(this);
        this.showDetailModal = this.showDetailModal.bind(this);
        this.getDetailPartenaire = this.getDetailPartenaire.bind(this);
    }
    componentDidMount() {
        this.getPartenaires();
    }
    async getPartenaires() {
        this.props.isLoading(true);
        let sCondition = "1";
        let sOrder = "dateCreation DESC";
        if (this.state.recherche.tri!="") {
            sOrder = this.state.recherche.tri;
        }
        // Condition de recherche
        if (this.state.recherche.motCle!="") {
            let motCle = this.state.recherche.motCle;
            motCle = motCle.toUpperCase();
            const tMotCle = motCle.replace(/'|,/g, " ").split(" ");
            let sAddCondition = "";
            for(const mot of tMotCle) {
                sAddCondition += ` AND (UPPER(entreprise) LIKE "%${mot}%" OR (UPPER(nui) LIKE "%${mot}%" OR (UPPER(banque) LIKE "%${mot}%" OR (UPPER(agenceBanque) LIKE "%${mot}%" OR (UPPER(numeroCompteBancaire) LIKE "%${mot}%" OR UPPER(ville) LIKE "%${mot}%" OR UPPER(pays)="${mot}" OR UPPER(bp)="${motCle}")`;
            }
            sCondition += sAddCondition;
        }
        new Data()
        .get("Partenaire", sCondition, "agents", sOrder, 1, 5000)
        .then(res => {
            let partenaires = res.rows;
            if (partenaires) {
                // Condition sur la date de la transaction
                sCondition = "";
                if (this.state.recherche.dateDebut!="" && this.state.recherche.dateFin!="") {
                    sCondition += ` AND dateCreation BETWEEN "${this.state.recherche.dateDebut}" AND "${this.state.recherche.dateFin}"`;
                } else if (this.state.recherche.dateFin!="") {
                    sCondition += ` AND dateCreation <= "${this.state.recherche.dateFin}"`;
                } else if (this.state.recherche.dateDebut!="") {
                    sCondition += ` AND dateCreation >= "${this.state.recherche.dateDebut}"`;
                }
                partenaires.forEach(partenaire => {
                    partenaire.approvisionnements = 0;
                    partenaire.commissionApprovisionnements = 0;
                    partenaire.retraits = 0;
                    partenaire.commissionRetraits = 0;
                    partenaire.commissions = 0;
                    partenaire.agents.forEach(async (utilisateur) => {
                        const approvisionnements = await new Data().exec(`/Transaction/sum?fields=montant&where=idAgent="${utilisateur.id}" AND type="APPROVISIONNEMENT GUICHET" AND status="SUCCESSFUL" ${sCondition}`);
                        utilisateur.approvisionnements = approvisionnements.value || 0;
                        utilisateur.commissionApprovisionnements = utilisateur.approvisionnements * partenaire.tauxApprovisionnement;
                        const retraits = await new Data().exec(encodeURI(`/Transaction/sum?fields=montant&where=idAgent="${utilisateur.id}" AND type="RETRAIT GUICHET" AND status="SUCCESSFUL" ${sCondition}`));
                        utilisateur.retraits = retraits.value || 0;
                        utilisateur.commissionRetraits = utilisateur.retraits * partenaire.tauxRetrait;
                        utilisateur.commissions = utilisateur.commissionApprovisionnements + utilisateur.commissionRetraits;
                        partenaire.approvisionnements += +utilisateur.approvisionnements;
                        partenaire.commissionApprovisionnements += utilisateur.commissionApprovisionnements;
                        partenaire.retraits += +utilisateur.retraits;
                        partenaire.commissionRetraits += utilisateur.commissionRetraits;
                        partenaire.commissions += utilisateur.commissions;
                    });
                });
                this.setState({partenaires: partenaires});
            }
        })
        .catch(err => {
            console.warn("Error : ", err);
        })
        .finally(() => {
            this.props.isLoading(false);
        });
        window.scrollTo(0,0);
    }

    handleInputRecherche(event) {
        let target = event.target;
        const name = target.name;
        const value = target.value;
        let recherche = this.state.recherche;
        recherche[name] = value;
        this.setState({recherche: recherche});
    }

    handleRechercheForm(event) {
        event.preventDefault();
        this.getPartenaires();
    }

    getDetailPartenaire(partenaire) {
        this.setState({partenaire: partenaire}, () => {
            this.showDetailModal();
        });
    }

    showDetailModal(show=true) {
        this.setState({showDetail: show});
    }

    render() {
        return (
            <div className="container-fluid">
                <Notification options={{top: "100px"}} />
                <div className="row">
                    <div className="col-sm-12 my-3">
                        <div className="border p-3">
                            <form className="row" onSubmit={this.handleRechercheForm}>
                                <div className="col-6 col-md-4">
                                    <input className="form-control" type="text" name="motCle" placeholder="Recherche (ID transaction, nom, prénom, devise)" value={this.state.recherche.motCle} onChange={this.handleInputRecherche} />
                                </div>
                                <div className="col-6 col-md-2">
                                    <input className="form-control" type="date" name="dateDebut" placeholder="Début" value={this.state.recherche.dateDebut} onChange={this.handleInputRecherche} />
                                </div>
                                <div className="col-6 col-md-2">
                                    <input className="form-control" type="date" name="dateFin" placeholder="Fin" value={this.state.recherche.dateFin} onChange={this.handleInputRecherche} />
                                </div>
                                <div className="col-6 col-md-2">
                                    <select className="form-control" name="tri" value={this.state.recherche.motCle} onChange={this.handleInputRecherche}>
                                        <option value="">Ordre de tri</option>
                                        <option value="entreprise ASC">Ordre croissant de entreprise</option>
                                        <option value="entreprise DESC">Ordre décroissant de entreprise</option>
                                        <option value="dateCreation ASC">Ordre croissant de date d'inscription</option>
                                        <option value="dateCreation DESC">Ordre décroissant de date d'inscription</option>
                                    </select>
                                </div>
                                <div className="col-12 col-md-2">
                                    <button className="btn btn-secondary btn-block" type="submit">
                                        <span className="d-none d-md-inline">Rechercher</span>
                                        <span className="d-inline d-md-none">Rechercher</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="row" ref={(myRef) => {this.printableToPDF = myRef}}>
                    <div className="col-sm-12 col-md-8 my-3">
                        <h3>
                            Etat Financier
                        </h3>
                        {
                            (this.state.recherche.motCle!="") &&
                            <h5>
                                Filtre : 
                                {(this.state.recherche.motCle!="")?<span> {this.state.recherche.motCle.toUpperCase()}, </span>:""}
                            </h5>
                        }
                    </div>
                    <div className="col-sm-12 col-md-4 text-right my-0 my-md-3">
                        <ReactToPrint 
                            filename="africpay-transactions.pdf"
                            content={() => this.printableToPDF}
                            trigger={() => <button className="btn btn-secondary">Imprimer</button>}
                        />
                    </div>
                    {this.state.partenaires.map(partenaire => 
                    <div className="col-sm-12 mb-3" key={"partenaire-"+partenaire.id}>
                        <div className="card">
                            <div className="card-header">
                                <h5 className="d-flex justify-content-between"  data-toggle="collapse" data-target={"#collapse-"+partenaire.id} aria-expanded="false" aria-controls={"#collapse-"+partenaire.id}>
                                    <span>{partenaire.entreprise}</span>
                                    <span>
                                        <i className="fa fa-chevron-right"></i>
                                        <i className="fa fa-chevron-down"></i>
                                    </span>
                                </h5>
                            </div>
                            <div className="card-body collapse" id={"collapse-"+partenaire.id}>
                                <table className="table table-boder">
                                    <thead>
                                        <tr>
                                            <th>Utilisateurs</th>
                                            <th>Approvisionnements</th>
                                            <th>Commissions</th>
                                            <th>Retraits</th>
                                            <th>Commisions</th>
                                            <th>Total Commission</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {partenaire.agents.map(utilisateur =>
                                        <tr key={"tr-agent-"+utilisateur.id}>
                                            <td>{utilisateur.nom + " " + utilisateur.prenom}</td>
                                            <td>{utilisateur.approvisionnements}</td>
                                            <td>{utilisateur.commissionApprovisionnements}</td>
                                            <td>{utilisateur.retraits}</td>
                                            <td>{utilisateur.commissionRetraits}</td>
                                            <td>{utilisateur.commissions}</td>
                                        </tr>
                                        )}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th>Totaux</th>
                                            <th>{partenaire.approvisionnements}</th>
                                            <th>{partenaire.commissionApprovisionnements}</th>
                                            <th>{partenaire.retraits}</th>
                                            <th>{partenaire.commissionRetraits}</th>
                                            <th>{partenaire.commissions}</th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div className="card-footer">
                                <div className="d-flex justify-content-between">
                                    <span onClick={() => this.getDetailPartenaire(partenaire)}>Voir les informations de {partenaire.entreprise}</span>
                                    {(partenaire.approvisionnements>0 || partenaire.retraits>0) && 
                                    <button className="btn btn-secondary btn-sm" type="button">Enregistrer la compensassion</button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    )}
                </div>
                {(this.state.partenaire) &&
                <Modal show={this.state.showDetail} onHide={() => {this.showDetailModal(false)}} className="mt-4">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Détails du partenaire {this.state.partenaire.entreprise}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mx-3">
                            <table className="table table-sm">
                                <tbody>
                                    <tr className="row">
                                        <td className="col-sm-5">ID : </td>
                                        <td className="col-sm-7">{this.state.partenaire.id}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Entreprise : </td>
                                        <td className="col-sm-7">{this.state.partenaire.entreprise}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">NUI : </td>
                                        <td className="col-sm-7">{this.state.partenaire.nui}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Pays : </td>
                                        <td className="col-sm-7">{this.state.partenaire.pays}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Ville : </td>
                                        <td className="col-sm-7">{this.state.partenaire.ville}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">B.P. : </td>
                                        <td className="col-sm-7">{this.state.partenaire.bp}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Banque : </td>
                                        <td className="col-sm-7">{this.state.partenaire.banque}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Agence banque : </td>
                                        <td className="col-sm-7">{this.state.partenaire.agenceBanque}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Numéro de compte bancaire : </td>
                                        <td className="col-sm-7">{this.state.partenaire.numeroCompteBancaire}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-9">Peut effectuer des approvisionnements ? : </td>
                                        <td className="col-sm-3">{(this.state.partenaire.hasApprovisionnement)?<span className="bg-success px-3 py-1">Oui</span>:<span className="bg-danger px-3 py-1">Non</span>}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Taux d'approvisionnement : </td>
                                        <td className="col-sm-7">{this.state.partenaire.tauxApprovisionnement}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-9">Peut effectuer des retrait ? : </td>
                                        <td className="col-sm-3">{(this.state.partenaire.actif==1)?<span className="bg-success px-3 py-1">Oui</span>:<span className="bg-danger px-3 py-1">Non</span>}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Taux de retrait : </td>
                                        <td className="col-sm-7">{this.state.partenaire.tauxRetrait}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Date de contrat : </td>
                                        <td className="col-sm-7"><Moment format="DD/MM/YYYY">{this.state.partenaire.dateContrat}</Moment></td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Date d'enregistrement : </td>
                                        <td className="col-sm-7"><Moment format="DD/MM/YYYY à HH:mm">{this.state.partenaire.dateCreation}</Moment></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={() => {this.showDetailModal(false)}}>Fermer</button>
                    </Modal.Footer>
                </Modal>
                }
            </div>
        );
    }
}

export default EtatFinancier;